import { IBrandRoutes } from './types';
import { LazyRoute, lazyWithFallback } from './util';

const TimsRewards: LazyRoute = lazyWithFallback(() => import('pages/account/tims-rewards'));
const TimCard: LazyRoute = lazyWithFallback(() => import('pages/account/tim-card'));
const Catering: LazyRoute = lazyWithFallback(() => import('components/catering'));
const TimsForGood: LazyRoute = lazyWithFallback(() => import('pages/campaigns/tims-for-good'));
const HockeyChallenge: LazyRoute = lazyWithFallback(() =>
  import('pages/campaigns/hockey-challenge')
);
const TimbitsLTO: LazyRoute = lazyWithFallback(() => import('pages/campaigns/timbits-lto'));
const RollUpHomePage: LazyRoute = lazyWithFallback(() =>
  import('pages/campaigns/roll-up-to-win/pages/roll-up-home-page')
);
const RollUpSharedRollsPage: LazyRoute = lazyWithFallback(() =>
  import('pages/campaigns/roll-up-to-win/pages/shared-rolls-page')
);
const ScanTimCard: LazyRoute = lazyWithFallback(() => import('pages/scan/tim-card'));
const ScanTimRewards: LazyRoute = lazyWithFallback(() => import('pages/scan/tim-rewards'));
const WorthTheWait: LazyRoute = lazyWithFallback(() => import('pages/campaigns/worth-the-wait'));

const brandRoutes: IBrandRoutes = {
  'routes.catering': Catering,
  'routes.rollUpTheRim': RollUpHomePage,
  'routes.rollUpTheRimOtherLanguage': RollUpHomePage,
  'routes.rollUpTheRimSharedRolls': RollUpSharedRollsPage,
  'routes.rollUpTheRimSharedRollsOtherLanguage': RollUpSharedRollsPage,
  'routes.timCard': TimCard,
  'routes.timsRewards': TimsRewards,
  'routes.scanTimCard': ScanTimCard,
  'routes.scanTimRewards': ScanTimRewards,
  'routes.timsRewardsTab': TimsRewards,
  'routes.tims-for-good-en': TimsForGood,
  'routes.tims-for-good-fr': TimsForGood,
  'routes.hockey-challenge-en': HockeyChallenge,
  'routes.hockey-challenge-fr': HockeyChallenge,
  'routes.timbitsLTO': TimbitsLTO,
  'routes.worthTheWait': WorthTheWait,
};

export default brandRoutes;
